module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/reports/reports.component.html
// module id = ./src/app/Pages/reports/reports.component.html
// module chunks = main